<template>
  <div class="extra-menu">
    <!-- <div class="menu-item" @click="openInnerWeb">
      <Icon type="leaf"></Icon>
      <div>内网</div>
    </div> -->
    <div
      class="menu-item"
      @click="openDefaultBrowser"
      title="查看当前页面的帮助文档"
    >
      <Icon type="social-chrome"></Icon>
      <div>浏览器</div>
    </div>
    <div
      class="menu-item"
      @click="openFineReport"
      title="使用网页版报表"
    >
      <Icon type="pie-graph"></Icon>
      <div>报表</div>
    </div>
    <div class="menu-item" @click="$router.go(0)" title="数据重新加载">
      <Icon type="refresh"></Icon>
      <div>数据重载</div>
    </div>
    <iframe
      :src="iframeSrc"
      style="width:100px;height:100px;position:absolute;right:9999px;"
    ></iframe>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import ajax from '@/lib/ajax'
import axios from 'axios'
import util from "@/lib/util"
import { setTimeout } from 'timers'
import requestUrls from '@/lib/requestUrls'

export default {
  data() {
    return {
      userName: '',
      iframeSrc: ''
    }
  },
  computed: {
    username() {
      return this.$store.state.session.user.name
    }
  },
  methods: {
    openFineReport() {
      const appid = 'wx003757ee144cae06'
      const agentid = "1000093"
      const redirect_uri = encodeURIComponent(`${requestUrls.webReportUrl}/WebReport/qyweixin.html`)
      const state = 'FReport'
      const loginUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
      this.refreshWxConfig(loginUrl,appid, 'report')
    },
    openDefaultBrowser() {
      const appid = 'wx003757ee144cae06'
      const agentid = "1000052"
      const redirect_uri = encodeURIComponent("http://qy.chinapsp.cn:8884")
      const state = 2
      const loginUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
      this.refreshWxConfig(loginUrl,appid, 'browser')
    },
    async refreshWxConfig(loginUrl,appid, type) {
      // 微信环境下获取signature
      let ua = window.navigator.userAgent.toLowerCase()
      ua = ua.toLocaleLowerCase()
      if (ua.indexOf('windowswechat') !== -1 || ua.indexOf('wxwork') !== -1) {
        if (!abp.utils.getCookieValue('wxconfig')) {
          await this.getSignature()
          this.wxConfig(loginUrl,appid)
        } else {
          this.wxConfig(loginUrl,appid)
        }
      } else {
        if (type === 'report') {
          this.iframeSrc = ''
          // this.$Message.info('请在企业微信中点击【采联业务报表2.0】')
          this.$nextTick(async () => {
            this.iframeSrc = `${requestUrls.webReportUrl}/WebReport/ReportServer?op=fs_load&cmd=sso&fr_username=${this.username}&fr_password=Debug_Xinxibu1717`
            this.$Spin.show()
            await this.loadTime()
            this.$Spin.hide()
            window.open(`${requestUrls.webReportUrl}/WebReport/ReportServer?op=fs`)
            this.$Message.info('采联业务报表2.0已打开')
          })
          return
        }
        if (type === 'browser') {
          this.$Message.info('该功能仅提供给企业微信环境下打开系统默认浏览器使用')
          return
        }
        this.$Message.info('非企业微信环境')
      }
    },
    // 配置wx接口及跳转使用
    wxConfig(loginUrl,appid) {
      const URL = loginUrl
      let wxconfigStr = abp.utils.getCookieValue('wxconfig')
      let wxconfig = JSON.parse(wxconfigStr)
      wx.config({
        debug: false,
        beta: true,
        appId: appid,
        timestamp: wxconfig.timestamp,
        nonceStr: wxconfig.noncestr,
        signature: wxconfig.signature,
        jsApiList: ['openDefaultBrowser']
      })
      wx.ready(() => {
        // 默认浏览器打开附带code参数
        wx.invoke('openDefaultBrowser', {
          url: URL
        }, (res) => {
          if (res.err_msg == 'openDefaultBrowser:ok') {
            this.$Message.success('默认浏览器打开成功')
          }
        })
      })
      wx.error((res) => {
        alert(JSON.stringify(res))
      })
    },
    // 获取企业微信signature
    async getSignature() {
      let noncestr = this.randomString()
      let timestamp = (new Date().getTime()).toString()
      timestamp = timestamp.substr(0, 10)
      let url = window.location.href
      url = url.split('#')[0]
      let rep = await ajax.get('/api/services/app/Publish/GetWechatApiSign', {
        params: {
          noncestr: noncestr,
          timestamp: timestamp,
          url: url
        }
      })
      if (rep.data.success) {
        let tokenExpireDate = new Date(
          new Date().getTime() + 1000 * 7200
        )
        let wxconfig = JSON.stringify({
          noncestr: noncestr,
          timestamp: timestamp,
          url: url,
          signature: rep.data.result
        })
        abp.utils.setCookieValue(
          'wxconfig',
          wxconfig,
          tokenExpireDate,
          util.abp.appPath
        )
      }
    },
    randomString(len = 16) {
      let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      let maxPos = chars.length;
      let pwd = '';
      for (var i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    loadTime(time = 1000) {
      return new Promise(function(res, rej) {
        setTimeout(() => {
          res('timeout')
        }, time)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.extra-menu {
  position: absolute;
  right: 170px;
  top: 0;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  i {
    font-size: 16px;
  }
  .menu-item {
    margin: 0 8px;
  }
  .menu-item:hover {
    color: #2d8cf0;
    cursor: pointer;
  }
}
</style>
